import { debounce } from './debounce'

const scrollTopButton = document.getElementById('scroll-top-button')

window.addEventListener(
  'scroll',
  debounce(() => {
    if (window.scrollY > 1500) {
      scrollTopButton?.classList.add('active')
    } else {
      scrollTopButton?.classList.remove('active')
    }
  }),
)

scrollTopButton?.addEventListener('click', e => {
  e.preventDefault()
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
    replaceState: true,
  })
})
